import { whatIfInnerSelector } from '../../../WhatIfsSelector';

const propertyTaxAmount = (state, props) => (
  whatIfInnerSelector(state, props).PropertyTaxAmount
);

export default propertyTaxAmount;
